module.exports = __webpack_public_path__ + "static/greetingImage@2x-a9d15c2f95a40c430cfeea067371239c.png";